export class GraphData {
  methodOfOperationId: string;
  isQuestionData = false;
  questionId: string;
  singleChoice: string;
  selectedChoices: string[];
  userProfileData: any = new Choice();
  isUserProfileData = false;
  industryId: string[];
  itBudgetId: string[];
  geographyId: string[];
  lineOfBusinessId: string[];
  countryId: string[];
  jobTitleId: string[];
  globalRevenueId: string[];
  employeeSizeId: any[];
  // top: number;
  // topType: any;
}

export class Choice {
  type: string;
  values: any[];
  operationId: string;
}



// WEBPACK FOOTER //
// ./src/app/feature/main/roles-shared/models/graphData.ts